import React, { Component } from 'react';
import {
  extractImage,
  ORIGINAL,
} from '../lib/image-versions';

class PurchaseImage extends Component {
  constructor(props) {
    super(props);
    this.onImageClick = this.onImageClick.bind(this);
  }

  onImageClick() {
    this.props.onClick();
  }

  image() {
    const { images } = this.props;
    return extractImage(images, this.props.version, this.props.defaultImageUrl);
  }

  render() {
    return (
      <img
        src={this.image().url}
        alt={this.props.alt || this.image().name}
        className={`media-object ${this.props.className}`}
        onClick={this.onImageClick}
      />
    );
  }
}

PurchaseImage.defaultProps = {
  onClick: () => {},
  version: ORIGINAL,
  className: '',
  alt: null,
  images: [],
};

export default PurchaseImage;



// WEBPACK FOOTER //
// ./src/components/purchase-image.js